const { getElement } = window.BAO.Utils

export class ProductFixedBar extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return ['product-form']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      event => this.dispatchQuantityChange(event),
    )

    this.listeners.add(
      document.body,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      event => this.syncExternalQuantityChange(event),
    )

    this.observer = new IntersectionObserver(entries =>
      this.toggleVisibility(entries),
    )
    this.observer.observe(this.externalEls['product-form'].element)
  }

  /** @param {IntersectionObserverEntry[]} entries */
  toggleVisibility (entries) {
    const boundingClientRect = this.getBoundingClientRect()
    entries.forEach(entry => {
      const isAbove = entry.boundingClientRect.y < boundingClientRect.y
      const isVisible = entry.isIntersecting

      this.toggleAttribute('visible', !isVisible && isAbove)
      document.documentElement.style.setProperty(
        '--Footer_Offset',
        !isVisible && isAbove ? '90px' : '0',
      )
    })
  }

  /**
   * @param {CustomEvent<{
   *  oldValue: number;
   *  value: number;
   * }>} event
   */
  dispatchQuantityChange (event) {
    this.dispatchEvent(
      new CustomEvent('product-fixed-bar:quantity-change', {
        bubbles: true,
        detail: {
          formId: this.dataset.formId,
          quantity: event.detail.value,
        },
      }),
    )
  }

  /**
   * @param {CustomEvent<{
   *  oldValue: number;
   *  value: number;
   * }>} event
   */
  syncExternalQuantityChange (event) {
    const { value } = event.detail
    const isRelated = event.target.closest(`form#${this.dataset.formId}`)

    if (!isRelated) {
      return
    }

    /**
     * @note we must select the input rather than quantity-adjuster
     * to prevent an 'input' event being dispatched
     */
    const quantityAdjuster = getElement('quantity-adjuster input', {
      context: this,
    })

    if (quantityAdjuster.value === value) {
      return
    }

    quantityAdjuster.value = value
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar, {
    extends: 'aside',
  })
}
